<div class="action-button">
    <button
        tooltip=""
        triggers=""
        placement="left"
        [disabled]="enableSpinner || _disabled"
        [ngClass]="classes"
        (click)="onClickButton($event)"
        [ngStyle]="ngStyle"
        >
        {{ label }}
        <i class="material-icons">{{ icon }}</i>
    </button>
</div>
